import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { NavigationItems } from "./Navigation";
import { NavigationRoutes } from "./Routes";
import { Footer } from "./Footer";
import { useLocalize } from "../hooks/useLocalize";
import { profileCopy, type ProfileLanguage } from "../i18n/profile";
import { updatePageMetadata } from "../common/seo";
export default function App() {
  const { pathname, hash } = useLocation();
  const { language } = useLocalize();
  const copy = profileCopy[language as ProfileLanguage] || profileCopy.en;
  const legal = /\/(privacy|imprint)\/?$/.test(pathname);
  useEffect(() => { updatePageMetadata(language as ProfileLanguage, pathname); }, [language, pathname]);
  useEffect(() => {
    if (hash) { requestAnimationFrame(() => document.getElementById(hash.slice(1))?.scrollIntoView()); }
    else { window.scrollTo(0, 0); }
  }, [pathname, hash]);
  return <div id="top"><a className="skip-link" href="#main-content">{copy.skip}</a><NavigationItems /><main id="main-content" className={legal ? "legal-page section-shell" : undefined} tabIndex={-1}><NavigationRoutes /></main><Footer /></div>;
}
